export enum LoadingStatus {
  NotLoaded = 1,
  Loading = 2,
  Loaded = 3,
  FailedToLoad = 4,
  Timeout = 5,
  NotFound = 6,
}
